<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>


<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <form *ngIf="!modalData.isEdit" [formGroup]="calculateForm">
    <div class="form-group row justify-content-center mt-2">
      <label class="col-3 col-form-label">ประเภท</label>
      <div class="col-9">
        <select class="custom-select" formControlName="TYPE" (change)="changeType(true)">
          <option hidden value="">เลือกประเภท</option>
          <option value="multiple_choice">Multiple Choice</option>
          <option value="rating">Rating</option>
          <option value="most/least">Most/Least</option>
          <option value="ranking">Ranking</option>
        </select>
      </div>
      <small *ngIf="!isHaveChoice && calculateForm.value.TYPE" class="text-danger">
        ** แบบทดสอบนี้ไม่มีข้อประเภท {{calculateForm.value.TYPE}}
      </small>
    </div>
    <div>
      <div *ngIf="calculateForm.value.TYPE === 'multiple_choice'">
        <div class="row form-group">
          <label class="col-3 col-form-label">ข้อ : เฉลย</label>
          <div class="col-9">
            <nz-select class="col-12" nzMode="multiple" nzPlaceHolder="กรุณาเลือกคำตอบที่ถูกต้อง (ข้อ : เฉลย)"
              formControlName="NUM_ANSWER" (ngModelChange)="sortByArray($event)">
              <nz-option *ngFor="let choice of allChoice" [nzLabel]="choice.LABEL" [nzValue]="choice"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>

      <div *ngIf="calculateForm.value.TYPE === 'rating'">
        <div>
          <div class="row form-group">
            <label class="col-3 col-form-label">Range</label>
            <div class="col-3">
              <input formControlName="MIN_RANGE" class="form-control" type="number" placeholder="min">
            </div>
            <label class="col-form-label">-</label>
            <div class="col-3">
              <input formControlName="MAX_RANGE" class="form-control" type="number" placeholder="max">
            </div>
          </div>
          <div *ngIf="calculateForm.value.NUM_ANSWER_ARR.length > 0" class="row" style="margin-top: -20px;">
            <label class="offset-9 col-form-label"><b>Invert</b></label>
          </div>
          <div *ngIf="calculateForm.value.NUM_ANSWER_ARR">
            <div *ngFor="let ans of calculateForm.get('NUM_ANSWER_ARR')['controls']; let i = index;"
              formArrayName="NUM_ANSWER_ARR">
              <div [formGroupName]="i" class="row form-group">
                <label *ngIf="i === 0" class="col-3 col-form-label">ข้อ</label>
                <label *ngIf="i > 0" class="col-3 col-form-label"></label>
                <div class="col-6">
                  <select class="custom-select" formControlName="ID" (change)="changeSelectValue(ans, $event)">
                    <option hidden value="">เลือกข้อ</option>
                    <option *ngFor="let choice of allChoice" [value]="choice.ID">{{ choice.NUMBER }}</option>
                  </select>
                  <small *ngIf="ans.value.CHOICES_LENGTH" class="lifedi-color">
                    จำนวนระดับ {{ans.value.CHOICES_LENGTH}}
                  </small>
                </div>
                <div class="col-1">
                  <mat-checkbox class="col-form-label" formControlName="INVERT"></mat-checkbox>
                </div>
                <div *ngIf="i > 0" class="col-1">
                  <button mat-mini-fab class="img" (click)="removeAnswer(i)"
                    [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2 justify-content-center">
            <button mat-mini-fab class="img" (click)="addRating()"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="calculateForm.value.TYPE === 'most/least'">
        <div *ngFor="let item of calculateForm.get('NUM_ANSWER_ARR')['controls']; let i = index;"
          formArrayName="NUM_ANSWER_ARR" class="box mb-3">
          <div [formGroupName]="i">
            <div *ngIf="i > 0" class="row" style="float: right;">
              <button mat-mini-fab class="img" style=" right: 15px; top: -10px;" (click)="removeAnswer(i)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'">
              </button>
            </div>

            <div class="row form-group">
              <label class="col-3 col-form-label">ข้อ</label>
              <div class="col-7">
                <select class="custom-select" formControlName="ID" (change)="changeSelectMostLeast(item, $event)">
                  <option hidden value="">เลือกข้อ</option>
                  <option *ngFor="let choice of allChoice" [value]="choice.ID">{{ choice.NUMBER }}</option>
                </select>
              </div>
            </div>
            <div *ngIf="calculateForm.value.NUM_ANSWER_ARR[i].ID" class="row form-group">
              <label class="col-3 col-form-label">เฉลย</label>
              <div class="col-4">
                <select class="custom-select" formControlName="most" (change)="selectAnswerMostLeast(item, 0)">
                  <option selected hidden disabled value="null">เลือก Most</option>
                  <option *ngFor="let choice of calculateForm.value.NUM_ANSWER_ARR[i].data_answer"
                    [value]="choice.choice_id">
                    {{ choice.choice_detail }}
                  </option>
                </select>
              </div>
              <div class="col-4">
                <select class="custom-select" formControlName="least" (change)="selectAnswerMostLeast(item, 1)">
                  <option selected hidden disabled value="null">เลือก Least</option>
                  <option *ngFor="let choice of calculateForm.value.NUM_ANSWER_ARR[i].data_answer"
                    [value]="choice.choice_id">
                    {{ choice.choice_detail }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2 justify-content-center">
          <button mat-mini-fab class="img" (click)="addMostLeast()"
            [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
          </button>
        </div>
      </div>

      <div *ngIf="calculateForm.value.TYPE === 'ranking'">
        <div *ngFor="let item of calculateForm.get('DATA')['controls']; let i = index;" class="box mb-3"
          formArrayName="DATA">
          <div [formGroupName]="i">
            <div *ngIf="i > 0" class="row" style="float: right;">
              <button mat-mini-fab class="img" style=" right: 15px; top: -10px;" (click)="removeRankingData(i)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'">
              </button>
            </div>
            <div class="row form-group">
              <label class="col-3 col-form-label">ข้อ</label>
              <div class="col-8">
                <select class="custom-select" formControlName="ID" (change)="changeSelectRanking(item, $event)">
                  <option selected hidden disabled value="">เลือกข้อ</option>
                  <option *ngFor="let choice of allChoice" [value]="choice.ID">{{ choice.NUMBER }}</option>
                </select>
              </div>
            </div>
            <div *ngIf="item.value.ID">
              <div class="row" style="margin-top: -10px;">
                <label class="offset-10 col-form-label"><b>Invert</b></label>
              </div>
              <div *ngFor="let choice of item.get('NUM_ANSWER')['controls']; let j = index;" formArrayName="NUM_ANSWER">
                <div [formArrayName]="j" class="row form-group">
                  <label class="col-3 col-form-label">ตัวเลือกที่ต้องการ</label>
                  <div class="col-7">
                    <select class="custom-select" formControlName="choice_id" (change)="selectRanking(item, $event)">
                      <option selected hidden disabled value="">เลือกข้อ</option>
                      <option *ngFor="let choice of item.get('ALL_CHOICE')['controls']"
                        [value]="choice.value.choice_id">
                        {{ choice.value.choice_detail }}</option>
                    </select>
                  </div>
                  <div class="col-1">
                    <mat-checkbox class="col-form-label" formControlName="invert"
                      (change)="changeInvertRanking(item, $event)">
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-2 justify-content-center">
          <button mat-mini-fab class="img" (click)="addRanking()"
            [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="allChoice">
      <div *ngIf="modalData.typeReport !== 'standard'" class="form-group row justify-content-center">
        <label class="col-3 col-form-label">สูตร</label>
        <div class="col-9">
          <select class="custom-select" formControlName="FORMULA" (change)="changeFormula()">
            <option hidden value="">เลือกสูตร</option>
            <option value="sum">Sum</option>
            <option value="avg">Average</option>
            <option value="norm">Norm</option>
          </select>
        </div>
      </div>
      <div *ngIf="modalData.typeReport === 'standard'" class="form-group row justify-content-center">
        <label class="col-3 col-form-label">สูตร</label>
        <div class="col-9">
          <select class="custom-select" formControlName="FORMULA" (change)="changeFormula()">
            <option hidden value="">เลือกสูตร</option>
            <option value="norm">Norm</option>
          </select>
        </div>
      </div>
      <div *ngIf="calculateForm.value.FORMULA === 'sum' || calculateForm.value.FORMULA === 'avg'"
        class="form-group row justify-content-center">
        <label class="col-3 col-form-label">Output</label>
        <div class="col-9">
          <select formControlName="OUTPUT" class="custom-select">
            <option selected hidden disabled value="null">เลือก output</option>
            <option value="raw">Raw</option>
          </select>
        </div>
      </div>
      <div *ngIf="calculateForm.value.FORMULA === 'norm'" class="form-group row justify-content-center">
        <label class="col-2 col-form-label">(x-m)/sd</label>
        <div class="col-10">
          <div class="container">
            <div class="form-group row">
              <label class="col-2 col-form-label">x</label>
              <select formControlName="X" class="col-4 custom-select">
                <option hidden value="">เลือก x</option>
                <option value="sum">Sum</option>
                <option value="average">Average</option>
              </select>
              <label class="col-2 col-form-label">output</label>
              <select formControlName="OUTPUT" class="col-4 custom-select">
                <option hidden value="">เลือก output</option>
                <option value="percentile">Percentile</option>
                <option value="t-score">T score</option>
                <option value="z-score">Z score</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">m</label>
              <input formControlName="M" class="col-4 form-control" type="number">
              <label class="col-2 col-form-label">sd</label>
              <input formControlName="SD" class="col-4 form-control" type="number">
            </div>
          </div>
        </div>
      </div>



      <div *ngFor="let detail of detailArray.controls; let i = index" class="box mb-3" formArrayName="DETAIL">
        <div [formGroupName]="i">
          <div class="form-group row">
            <label class="col-3 col-form-label">Range คะแนน</label>
            <div class="col-3">
              <input type="number" class="form-control" formControlName="min_range" placeholder="min">
            </div>
            <label class="col-form-label">-</label>
            <div class="col-3">
              <input type="number" class="form-control" formControlName="max_range" placeholder="max">
            </div>
            <div *ngIf="i > 0" class="offset-1 col-1" style="padding-left: 40px;">
              <button mat-mini-fab class="img" (click)="removeDetail(i)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'">
              </button>
            </div>
          </div>
          <div class="form-group row justify-content-center">
            <label class="col-3 col-form-label">คำอธิบาย</label>
            <div class="col-9">
              <textarea class="w-100 form-control" rows="5" maxlength="1500" formControlName="description"></textarea>
              <p class="text-right">{{ detailArray.value[i].description.length | number }}/,1500</p>
            </div>
          </div>
        </div>
      </div>
      <button mat-mini-fab class="img mt-3" (click)="addScore()"
        [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
      </button>
    </div>
  </form>




  <form *ngIf="modalData.isEdit" [formGroup]="calculateForm">
    <div class="form-group row justify-content-center mt-2">
      <label class="col-3 col-form-label">ประเภท</label>
      <div class="col-9">
        <select class="custom-select" formControlName="TYPE" (change)="changeType(true)">
          <option hidden value="">เลือกประเภท</option>
          <option value="multiple_choice">Multiple Choice</option>
          <option value="rating">Rating</option>
          <option value="most/least">Most/Least</option>
          <option value="ranking">Ranking</option>
        </select>
      </div>
      <small *ngIf="!isHaveChoice && calculateForm.value.TYPE" class="text-danger">
        ** แบบทดสอบนี้ไม่มีข้อประเภท {{calculateForm.value.TYPE}}
      </small>
    </div>
    <div>
      <div *ngIf="calculateForm.value.TYPE === 'multiple_choice' && calculateForm.value.NUM_ANSWER">
        <div class="row form-group">
          <label class="col-3 col-form-label">ข้อ : เฉลย</label>
          <div class="col-9">
            <nz-select class="col-12" nzMode="multiple" nzPlaceHolder="กรุณาเลือกคำตอบที่ถูกต้อง (ข้อ : เฉลย)"
              formControlName="NUM_ANSWER" (ngModelChange)="sortByArray($event)" [compareWith]="compareMultipleChoice">
              <nz-option *ngFor="let choice of allChoice" [nzLabel]="choice.LABEL" [nzValue]="choice"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>

      <div *ngIf="calculateForm.value.TYPE === 'rating' && calculateForm.value.NUM_ANSWER_ARR">
        <div>
          <div class="row form-group">
            <label class="col-3 col-form-label">Range</label>
            <div class="col-3">
              <input formControlName="MIN_RANGE" class="form-control" type="number" placeholder="min">
            </div>
            <label class="col-form-label">-</label>
            <div class="col-3">
              <input formControlName="MAX_RANGE" class="form-control" type="number" placeholder="max">
            </div>
          </div>
          <div *ngIf="calculateForm.value.NUM_ANSWER_ARR.length > 0" class="row" style="margin-top: -20px;">
            <label class="offset-9 col-form-label"><b>Invert</b></label>
          </div>
          <div *ngIf="calculateForm.value.NUM_ANSWER_ARR">
            <div *ngFor="let ans of calculateForm.get('NUM_ANSWER_ARR')['controls']; let i = index;"
              formArrayName="NUM_ANSWER_ARR">
              <div [formGroupName]="i" class="row form-group">
                <label *ngIf="i === 0" class="col-3 col-form-label">ข้อ</label>
                <label *ngIf="i > 0" class="col-3 col-form-label"></label>
                <div class="col-6">
                  <select class="custom-select" formControlName="ID" (change)="changeSelectValueEdit(ans, $event, i)">
                    <option hidden value="">เลือกข้อ</option>
                    <option *ngFor="let choice of allChoice" [value]="choice.ID">{{ choice.NUMBER }}</option>
                  </select>
                  <small *ngIf="ans.value.CHOICES_LENGTH" class="lifedi-color">
                    จำนวนระดับ {{ans.value.CHOICES_LENGTH}}
                  </small>
                </div>
                <div class="col-1">
                  <mat-checkbox class="col-form-label" formControlName="INVERT"
                    (change)="changeInvertEdit('rating', $event, i)">
                  </mat-checkbox>
                </div>
                <div *ngIf="i > 0" class="col-1">
                  <button mat-mini-fab class="img" (click)="removeAnswer(i)"
                    [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2 justify-content-center">
            <button mat-mini-fab class="img" (click)="addRating()"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="calculateForm.value.TYPE === 'most/least'">
        <div *ngFor="let item of calculateForm.get('NUM_ANSWER_ARR')['controls']; let i = index;"
          formArrayName="NUM_ANSWER_ARR" class="box mb-3">
          <div [formGroupName]="i">
            <div *ngIf="i > 0" class="row" style="float: right;">
              <button mat-mini-fab class="img" style=" right: 15px; top: -10px;" (click)="removeAnswer(i)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'">
              </button>
            </div>

            <div class="row form-group">
              <label class="col-3 col-form-label">ข้อ</label>
              <div class="col-7">
                <select class="custom-select" formControlName="ID"
                  (change)="changeSelectMostLeastEdit(item, $event, i)">
                  <option hidden value="">เลือกข้อ</option>
                  <option *ngFor="let choice of allChoice" [value]="choice.ID">{{ choice.NUMBER }}</option>
                </select>
              </div>
            </div>
            <div *ngIf="calculateForm.value.NUM_ANSWER_ARR[i].ID" class="row form-group">
              <label class="col-3 col-form-label">เฉลย</label>
              <div class="col-4">
                <select class="custom-select" formControlName="most" (change)="selectAnswerMostLeastEdit(item, 0, i)">
                  <option selected hidden disabled value="null">เลือก Most</option>
                  <option *ngFor="let choice of calculateForm.value.NUM_ANSWER_ARR[i].data_answer"
                    [value]="choice.choice_id">
                    {{ choice.choice_detail }}
                  </option>
                </select>
              </div>
              <div class="col-4">
                <select class="custom-select" formControlName="least" (change)="selectAnswerMostLeastEdit(item, 1, i)">
                  <option selected hidden disabled value="null">เลือก Least</option>
                  <option *ngFor="let choice of calculateForm.value.NUM_ANSWER_ARR[i].data_answer"
                    [value]="choice.choice_id">
                    {{ choice.choice_detail }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2 justify-content-center">
          <button mat-mini-fab class="img" (click)="addMostLeast()"
            [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
          </button>
        </div>
      </div>

      <div *ngIf="calculateForm.value.TYPE === 'ranking'">
        <div *ngFor="let item of calculateForm.get('DATA')['controls']; let i = index;" class="box mb-3"
          formArrayName="DATA">
          <div [formGroupName]="i">
            <div *ngIf="i > 0" class="row" style="float: right;">
              <button mat-mini-fab class="img" style=" right: 15px; top: -10px;" (click)="removeRankingData(i)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'">
              </button>
            </div>
            <div class="row form-group">
              <label class="col-3 col-form-label">ข้อ</label>
              <div class="col-8">
                <select class="custom-select" formControlName="ID" (change)="changeSelectRanking(item, $event)">
                  <option selected hidden disabled value="">เลือกข้อ</option>
                  <option *ngFor="let choice of allChoice" [value]="choice.ID">{{ choice.NUMBER }}</option>
                </select>
              </div>
            </div>
            <div *ngIf="item.value.ID">
              <div class="row" style="margin-top: -10px;">
                <label class="offset-10 col-form-label"><b>Invert</b></label>
              </div>
              <div *ngFor="let choice of item.get('NUM_ANSWER')['controls']; let j = index;" formArrayName="NUM_ANSWER">
                <div [formArrayName]="j" class="row form-group">
                  <label class="col-3 col-form-label">ตัวเลือกที่ต้องการ</label>
                  <div class="col-7">
                    <select class="custom-select" formControlName="choice_id" (change)="selectRanking(item, $event)">
                      <option selected hidden disabled value="">เลือกข้อ</option>
                      <option *ngFor="let choice of item.get('ALL_CHOICE')['controls']"
                        [value]="choice.value.choice_id">
                        {{ choice.value.choice_detail }}</option>
                    </select>
                  </div>
                  <div class="col-1">
                    <mat-checkbox class="col-form-label" formControlName="invert"
                      (change)="changeInvertRanking(item, $event)">
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-2 justify-content-center">
          <button mat-mini-fab class="img" (click)="addRanking()"
            [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="allChoice">
      <div *ngIf="modalData.typeReport !== 'standard'" class="form-group row justify-content-center">
        <label class="col-3 col-form-label">สูตร</label>
        <div class="col-9">
          <select class="custom-select" formControlName="FORMULA" (change)="changeFormula()">
            <option hidden value="">เลือกสูตร</option>
            <option value="sum">Sum</option>
            <option value="avg">Average</option>
            <option value="norm">Norm</option>
          </select>
        </div>
      </div>
      <div *ngIf="modalData.typeReport === 'standard'" class="form-group row justify-content-center">
        <label class="col-3 col-form-label">สูตร</label>
        <div class="col-9">
          <select class="custom-select" formControlName="FORMULA" (change)="changeFormula()">
            <option hidden value="">เลือกสูตร</option>
            <option value="norm">Norm</option>
          </select>
        </div>
      </div>
      <div *ngIf="calculateForm.value.FORMULA === 'sum' || calculateForm.value.FORMULA === 'avg'"
        class="form-group row justify-content-center">
        <label class="col-3 col-form-label">Output</label>
        <div class="col-9">
          <select formControlName="OUTPUT" class="custom-select">
            <option selected hidden disabled value="null">เลือก output</option>
            <option value="raw">Raw</option>
          </select>
        </div>
      </div>
      <div *ngIf="calculateForm.value.FORMULA === 'norm'" class="form-group row justify-content-center">
        <label class="col-2 col-form-label">(x-m)/sd</label>
        <div class="col-10">
          <div class="container">
            <div class="form-group row">
              <label class="col-2 col-form-label">x</label>
              <select formControlName="X" class="col-4 custom-select">
                <option hidden value="">เลือก x</option>
                <option value="sum">Sum</option>
                <option value="average">Average</option>
              </select>
              <label class="col-2 col-form-label">output</label>
              <select formControlName="OUTPUT" class="col-4 custom-select">
                <option hidden value="">เลือก output</option>
                <option value="percentile">Percentile</option>
                <option value="t-score">T score</option>
                <option value="z-score">Z score</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">m</label>
              <input formControlName="M" class="col-4 form-control" type="number">
              <label class="col-2 col-form-label">sd</label>
              <input formControlName="SD" class="col-4 form-control" type="number">
            </div>
          </div>
        </div>
      </div>



      <div *ngFor="let detail of detailArray.controls; let i = index" class="box mb-3" formArrayName="DETAIL">
        <div [formGroupName]="i">
          <div class="form-group row">
            <label class="col-3 col-form-label">Range คะแนน</label>
            <div class="col-3">
              <input type="number" class="form-control" formControlName="min_range" placeholder="min"
                (change)="changeRange('min',$event , i)">
            </div>
            <label class="col-form-label">-</label>
            <div class="col-3">
              <input type="number" class="form-control" formControlName="max_range" placeholder="max"
                (change)="changeRange('max',$event , i)">
            </div>
            <div *ngIf="i > 0" class="offset-1 col-1" style="padding-left: 40px;">
              <button mat-mini-fab class="img" (click)="removeDetail(i)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'">
              </button>
            </div>
          </div>
          <div class="form-group row justify-content-center">
            <label class="col-3 col-form-label">คำอธิบาย</label>
            <div class="col-9">
              <textarea class="w-100 form-control" rows="5" maxlength="1500" formControlName="description"
                (change)="changeDetail($event, i)"></textarea>
              <p class="text-right">{{ detailArray.value[i].description.length | number }}/1,500</p>
            </div>
          </div>
        </div>
      </div>
      <button mat-mini-fab class="img mt-3" (click)="addScore()"
        [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!modalData.isEdit" align="center">
  <!-- <button mat-button style="background: #3E8C1A; color: #fff;" (click)="addCalculate(calculateForm)">
    {{ modalData.actionBtnText }}
  </button> -->
  <button *ngIf="calculateForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addCalculate(calculateForm)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="!calculateForm.valid" mat-button disabled="true">
    {{ modalData.actionBtnText }}
  </button>
</mat-dialog-actions>

<mat-dialog-actions *ngIf="modalData.isEdit" align="center">
  <button *ngIf="calculateForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="editCalculate(calculateForm)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="!calculateForm.valid" mat-button disabled="true">
    {{ modalData.actionBtnText }}
  </button>
</mat-dialog-actions>